import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';

interface AgentBubbleProps {
  onClick: () => void;
}

export function AgentBubble({ onClick }: AgentBubbleProps) {
  return (
    <motion.button
      onClick={onClick}
      className="fixed bottom-4 right-4 z-50 h-14 w-14 rounded-full bg-gradient-to-r from-purple-500 via-blue-500 to-green-500 shadow-lg hover:shadow-xl transition-shadow flex items-center justify-center"
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.95 }}
      animate={{ scale: [1, 1.05, 1] }}
      transition={{ repeat: Infinity, duration: 2, ease: 'easeInOut' }}
      aria-label="Open AI Assistant"
      title="AI Assistant"
    >
      <Sparkles className="h-6 w-6 text-white" />
    </motion.button>
  );
}
